import { createFileRoute } from "@tanstack/react-router";
import { PostDetailPage } from "@/features/content/post-detail";

export const Route = createFileRoute("/_app/content/posts/$postId")({
  head: () => ({ meta: [{ title: "Post · Malfak" }] }),
  component: PostDetail,
});

function PostDetail() {
  const { postId } = Route.useParams();
  return <PostDetailPage postId={postId} />;
}
